import Vue from 'vue';

Vue.filter('trimPhone', (value: string): string => (`${value}`).replace('+1 ', '').replace('+1', ''));
